import React, { useEffect, useState } from "react";
import "../../Pages/HomePage.css";
import { Modal } from "react-bootstrap";
import { SlQuestion } from "react-icons/sl";

const NotificationModal = ({ label, show, handleClose, title, body }) => {
  const [isComplete, setIsComplete] = useState(true);

  useEffect(() => {
    const interval = setInterval(() => {
      setIsComplete((prevState) => !prevState);
    }, 1000); // 1 second interval

    return () => clearInterval(interval);
  }, []);
  return (
    <>
      {show && (
        <Modal show={show} onHide={handleClose} centered>
          <div className="notification-modal showNormalFont">
            <div className="modal-row center-content">
              {(label === "successPaymentCheck" || label === 'sucessDriveOff' || label === 'sucessSHOPLIFT' || label === 'sucessIOU') && (
                <div
                  className={`circle-loader ${
                    isComplete ? "load-complete" : ""
                  }`}
                >
                  <div
                    className={` checkmark ${isComplete ? "draw" : ""}`}
                  ></div>
                </div>
              )}
              {
                label==='referenceNumberCheck' && (
                  <div className="mb-2">
                    <SlQuestion style={{color:'#86c5da',fontSize:'5rem',fontWeight:'100'}}/>
                  </div>
                )
              }
            </div>
            <div className="modal-row center-content">
              <h2 id="notification-heading">{title}</h2>
            </div>
            <div className="modal-row center-content" id="notification-text">
              {body}
            </div>
            <div className="modal-row center-content">
              <button className="notification-cls-btn" onClick={handleClose}>
                OK
              </button>
            </div>
          </div>
        </Modal>
      )}
    </>
  );
};

export default NotificationModal;
